import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import PhotoIcon from '@material-ui/icons/Photo';
import TransformIcon from '@material-ui/icons/Transform';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import AutoRenewIcon from '@material-ui/icons/Autorenew';
import ClearIcon from '@material-ui/icons/Clear';
import MessageIcon from '@material-ui/icons/Message';
import EmailIcon from '@material-ui/icons/Email';
import _ from 'lodash';
import { SEND_EMAIL_DIALOG, SEND_SMS_DIALOG } from '../../../redux/constants/dialogs';

import {
  isStageComplete,
  isStageInProgress,
  formatLocation,
} from '../../../utils/helper';
import { hasPermission } from '../../../utils/authenticated';
import Grid from '../../Common/Grid/index';
import IdentityLabel from '../../Common/IdentityLabel/index';
import getNoDataCellComponent from '../../Common/NoDataCellComponent/index';

import styles from './styles';
import Tooltip from '@material-ui/core/Tooltip';

const getColumns = (stages) => _.flatten([
  { name: 'origin', title: 'Origin' },
  { name: 'destination', title: 'Destination' },
  { name: 'contact', title: 'Contact' },
  stages.map(stage => ({ name: `stage-${stage.id}`, title: stage.name })),
  { name: 'action', title: ' ' },
]);

const getColumnExtensions = (stages) => _.flatten([
  // { columnName: '', width: 0 },
  // { columnName: '', width: 0 },
  // { columnName: '', width: 0 },
  // { columnName: '', width: 0 },
  stages.map(stage => ({ columnName: `stage-${stage.id}`, width: 100 })),
  { columnName: 'action', width: 120 },
]);

const getCellComponent = (job, onViewImages, showDialog) => ({ row, column, value }) => {
  const colName = column.name.indexOf('stage-') === 0 ? 'stage' : column.name;

  switch (colName) {
    case 'origin':
    case 'destination':
      return formatLocation(value);
    case 'contact':
      return value ? (<IdentityLabel identity={value} showDialog={showDialog}/>) : null;
    case 'stage':
      const stageId = column.name.substring(6);
      return renderStageStatus(row, job.profile.stages.find(s => s.id === stageId));
    case 'action':
      return <div>
        {row.contact && row.contact.mobile ? <Tooltip placement="bottom" title="Send SMS">
          <IconButton
            onClick={() => showDialog(SEND_SMS_DIALOG, { contact: row.contact, params: { task: row, job } })}
          >
            <MessageIcon style={styles.icon}/>
          </IconButton></Tooltip> : null}

        {row.contact && row.contact.email ? <Tooltip placement="bottom" title="Send Email">
          <IconButton
            onClick={() => showDialog(SEND_EMAIL_DIALOG, { contact: row.contact, params: { task: row, job } })}
          >
            <EmailIcon style={styles.icon}/>
          </IconButton></Tooltip> : null}

        {hasImages(row) ? (<Tooltip placement="bottom" title="Photos">
          <IconButton
            onClick={(evt) => {
              evt.stopPropagation();
              onViewImages(job, row);
            }}
          >
            <PhotoIcon style={styles.icon}/>
          </IconButton></Tooltip>) : null}
      </div>
    default:
      return value;
  }
};

const hasImages = (task) => {
  // console.log('task', task);
  return (task.images && _.keys(task.images).length > 0) ||
    _.values(task.items || {}).find((item) => item.images && _.keys(item.images).length > 0) ||
    _.values(task.stages || {}).find((stage) => stage.qa && stage.qa.questions && _.values(stage.qa.questions).find((question) => question.images && _.values(question.images).length));
};

const renderStageStatus = (task, stage) => {
  if (isStageComplete(task, stage)) {
    // console.log('stage', stage);
    if (stage.qa) {
      return (<Tooltip title="Complete with Quality Control"><IconButton onClick={() => alert('show qa')}><DoneAllIcon
        style={styles.stageComplete}/></IconButton></Tooltip>);
    } else {
      return (<Tooltip title="Complete"><DoneIcon style={styles.stageComplete}/></Tooltip>);
    }

  } else if (isStageInProgress(task, stage)) {
    return (<Tooltip title="Pending"><AutoRenewIcon style={styles.stagePending}/></Tooltip>);
  }

  return (<ClearIcon style={styles.stageNotStarted}/>);
};

class TasksGrid extends Component {
  state = {};

  componentWillMount() {
    this.setState({
      editable: hasPermission(['JobCreator', 'Administrator']),
    });
  }

  handleViewImages = (job, task) => {
    console.log('handleViewImages', job, task);
  };

  //
  // handleRowSelection = (evt) => {
  //   console.log('setting data - 8');
  //   let selectedRows = [];
  //   switch (evt) {
  //     case 'all':
  //       selectedRows = _.range(0, Math.min(this.state.limit, this.state.data.length));
  //       break;
  //     case 'none':
  //       selectedRows = [];
  //       break;
  //     default:
  //       selectedRows = evt;
  //       break;
  //   }
  //
  //   this.setState({
  //     selectedRows,
  //   });
  //
  //   if (this.props.onRowSelection) {
  //     const { limit, page, data } = this.state;
  //     const items = data.slice((page - 1) * limit, page * limit);
  //     this.props.onRowSelection(selectedRows, items.filter((item, idx) => selectedRows.indexOf(idx) >= 0));
  //   }
  // };

  render() {
    const { job, data, showDialog, onEdit, onRemove } = this.props;

    return (<Grid
      columns={getColumns(job.profile.stages)}
      columnExtensions={getColumnExtensions(job.profile.stages)}
      data={data}
      fetch={_.noop}
      cellComponent={getCellComponent(job, this.handleViewImages, showDialog)}
      noDataCellComponent={getNoDataCellComponent(<TransformIcon style={styles.noData}/>, 'tasks')}
      onEdit={onEdit}
      onRemove={onRemove}
    />);
  }
}

TasksGrid.propTypes = {
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  onViewImages: PropTypes.func,
  onRowSelection: PropTypes.func,
  job: PropTypes.object.isRequired,
  data: PropTypes.object,
  showDialog: PropTypes.func.isRequired,
};

export default TasksGrid;



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksGrid/index.js